import React from "react";
import * as style from "./style.module.css";

const Component = ({ address }) => {
  return (
    <section>
      <div className={style.map_box}>
        <ul>
          <li>店名：Gemmy eye　中村橋駅前店</li>
          <li>住所：東京都練馬区中村北4-2-2 中村橋駅前ビル3Ｆ</li>
          <li>最寄り駅：西武池袋線　中村橋駅徒歩3分</li>
        </ul>
        <div className={style.map_group}>
          <iframe
          src={`https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d809.645669112057!2d139.6375722613052!3d35.736480722060634!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6018edb067bb0e2d%3A0x902d728034de561b!2z44CSMTc2LTAwMjMg5p2x5Lqs6YO957e06aas5Yy65Lit5p2R5YyX77yU5LiB55uu77yS4oiS77ySIOS4readkeapi-mnheWJjeODk-ODqw!5e0!3m2!1sja!2sjp!4v1721029805950!5m2!1sja!2sjp`}
          width="100%"
          height="450"
          frameborder="0"
          style={{ border: 0, marginBottom: "-0.5rem", filter:"hue-rotate(202deg)"}}
          allowfullscreen
          loading="lazy"
          title={`Google Map: 中村橋駅前店`}
          />
        </div>
      </div>

      <div className={style.map_box}>
        <ul>
          <li>店名：Gemmy eye　練馬店</li>
          <li>住所：東京都練馬区練馬1-1-4</li>
          <li>最寄り駅：西武池袋線練馬駅南口　徒歩30秒</li>
        </ul>
        <div className={style.map_group}>
          <iframe
            src={`https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d809.6306099557213!2d139.65650668857174!3d35.737961760237525!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6018ed0c249ff7e5%3A0x5cf95b28c967f59f!2z44CSMTc2LTAwMDEg5p2x5Lqs6YO957e06aas5Yy657e06aas77yR5LiB55uu77yR4oiS77yUIOatpuWGheODk-ODqw!5e0!3m2!1sja!2sjp!4v1721030842396!5m2!1sja!2sjp`}
            width="100%"
            height="450"
            frameborder="0"
            style={{ border: 0, marginBottom: "-0.5rem", filter:"hue-rotate(202deg)"}}
            allowfullscreen
            loading="lazy"
            title={`Google Map: 練馬店`}
          />
        </div>
      </div>
    </section>
  )
}

export default Component
